/* Shared cart flow for product pages and direct-add cards. Native forms are the fallback. */
(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const dialog = $('#erb-cart-confirmation');
  if (!dialog || typeof dialog.showModal !== 'function' || !window.fetch) return;
  const routes = JSON.parse($('#theme-routes')?.textContent || '{}');
  const track = $('[data-atc-track]', dialog);
  const recommendations = $('[data-atc-recommendations]', dialog);
  const pendingForms = new WeakSet();
  let opener, generation = 0, cartRefreshSequence = 0;
  let lastAdded;
  try { lastAdded = JSON.parse(sessionStorage.getItem('erb-cart-last-added') || 'null'); } catch {}
  function rememberAdded(item) {
    lastAdded = {key:item.key || '',id:String(item.variant_id || item.id)};
    try { sessionStorage.setItem('erb-cart-last-added', JSON.stringify(lastAdded)); } catch {}
  }
  function imageSource(value) {
    const src = typeof value === 'string' ? value : value?.src || value?.url;
    if (!src) return '';
    try { const url = new URL(src, location.origin); return /^https?:$/.test(url.protocol) ? url.href : ''; } catch { return ''; }
  }
  function formProduct(form, id) {
    const root = form.closest('[data-product-root],.erb-card');
    const json = $('[data-product-json]', root || form);
    let product;
    try { product = json ? JSON.parse(json.textContent) : null; } catch {}
    const variant = product?.variants.find(item => String(item.id) === String(id));
    return {
      id, product_id: product?.id || root?.dataset.productId,
      product_title: product?.title || root?.dataset.productTitle || '',
      variant_title: variant?.title || root?.dataset.productOption || '',
      image: imageSource(variant?.featured_image || product?.featured_image || root?.dataset.productImage),
      product, root
    };
  }
  function updateArrows() {
    const overflow = track.scrollWidth > track.clientWidth + 2;
    const prev = $('[data-atc-prev]', dialog), next = $('[data-atc-next]', dialog);
    prev.hidden = next.hidden = !overflow;
    prev.disabled = track.scrollLeft < 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }
  function renderRecommendations(cards, productId, cartIds) {
    const seen = new Set();
    const selected = cards.filter(card => {
      const id = card.dataset.productId;
      if (!id || id === String(productId) || cartIds?.has(id) || seen.has(id)) return false;
      seen.add(id); return true;
    }).slice(0,8);
    track.replaceChildren(...selected);
    track.scrollLeft = 0;
    recommendations.hidden = selected.length === 0;
    requestAnimationFrame(updateArrows);
  }
  async function loadRecommendations(productId, version, cartIds) {
    if (!productId) return;
    try {
      const endpoint = dialog.dataset.recommendationsUrl || `${routes.root || '/'}recommendations/products`;
      const url = new URL(endpoint, location.origin);
      url.searchParams.set('section_id', 'cart-recommendations');
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '8');
      url.searchParams.set('intent', 'related');
      const response = await fetch(url.pathname + url.search, {headers:{Accept:'text/html'}});
      if (!response.ok) return;
      const markup = await response.text();
      if (version !== generation || !dialog.open) return;
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const cards = $$('[data-cart-recommendation-results]>.erb-card', doc);
      if (cards.length) renderRecommendations(cards, productId, cartIds);
    } catch { /* Keep the available catalogue suggestions if recommendations are unavailable. */ }
  }
  function showConfirmation(item, source, trigger, {heading='Ajouté au panier',suggestions=true} = {}) {
    const version = ++generation;
    if (!dialog.open) opener = trigger;
    const title = item.product_title || source.product_title || item.title || '';
    const variant = item.variant_title || source.variant_title || '';
    const productId = item.product_id || source.product_id;
    $('#CartConfirmationTitle', dialog).textContent = heading;
    dialog.classList.toggle('erb-cart-confirmation--empty', !productId);
    dialog.removeAttribute('aria-busy');
    $('[data-added-name]', dialog).textContent = title;
    const option = $('[data-added-variant]', dialog);
    option.textContent = variant === 'Default Title' ? '' : variant;
    option.hidden = !option.textContent;
    const img = $('[data-added-image]', dialog);
    const src = imageSource(item.featured_image || item.image) || source.image;
    if (src) img.src = src; else img.removeAttribute('src');
    img.alt = title; img.hidden = !src;
    $('[data-added-cart-link]', dialog).textContent = 'Mon panier';
    const fallback = $('#erb-cart-recommendation-fallback');
    renderRecommendations(suggestions && fallback ? $$('.erb-card', fallback.content.cloneNode(true)) : [], productId);
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('erb-atc-open');
    dialog.scrollTop = 0;
    $('[data-close-cart-confirmation]', dialog).focus({preventScroll:true});
    requestAnimationFrame(updateArrows);
    return {version, productId};
  }
  function applyCart(cart, confirmation) {
    if (Number.isInteger(cart.item_count) && cart.item_count >= 0) {
      $$('[data-cart-count]').forEach(el => {el.textContent=cart.item_count;el.hidden=cart.item_count===0;});
      if (confirmation.version === generation) $('[data-added-cart-link]',dialog).textContent=`Mon panier (${cart.item_count})`;
    }
    const cartIds = new Set((cart.items || []).map(item => String(item.product_id)));
    if (confirmation.version === generation && dialog.open) renderRecommendations($$('.erb-card', track), confirmation.productId, cartIds);
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
    return cartIds;
  }
  async function refreshCart(confirmation) {
    const refreshSequence = ++cartRefreshSequence;
    let cartIds;
    try {
      const response = await fetch((routes.cart || '/cart') + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (response.ok) {
        const cart = await response.json();
        if (refreshSequence !== cartRefreshSequence) return;
        cartIds = applyCart(cart, confirmation);
      }
    } catch { /* The add succeeded: a counter refresh failure must not invite a duplicate add. */ }
    if (confirmation.version === generation && dialog.open) loadRecommendations(confirmation.productId, confirmation.version, cartIds);
  }
  async function openExistingCart(trigger) {
    if (dialog.open) { $('[data-close-cart-confirmation]', dialog).focus({preventScroll:true}); return; }
    const pending = showConfirmation({product_title:'Chargement du panier…'}, {}, trigger, {heading:'Votre panier',suggestions:false});
    dialog.setAttribute('aria-busy','true');
    const refreshSequence = ++cartRefreshSequence;
    try {
      const response = await fetch((routes.cart || '/cart') + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items) || !Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('Invalid cart');
      if (pending.version !== generation || refreshSequence !== cartRefreshSequence || !dialog.open) return;
      const item = cart.items.find(item => lastAdded?.key && item.key === lastAdded.key)
        || cart.items.find(item => String(item.variant_id || item.id) === lastAdded?.id) || cart.items[0];
      const confirmation = showConfirmation(item || {product_title:'Votre panier est vide'}, {}, trigger, {heading:'Votre panier',suggestions:!!item});
      const cartIds = applyCart(cart, confirmation);
      if (item) loadRecommendations(confirmation.productId, confirmation.version, cartIds);
    } catch {
      if (pending.version !== generation || !dialog.open) return;
      showConfirmation({product_title:'Impossible de charger le panier',variant_title:'Réessayez ou ouvrez la page panier.'}, {}, trigger, {heading:'Votre panier',suggestions:false});
    }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('[data-open-cart]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (trigger.target && trigger.target !== '_self')) return;
    event.preventDefault();
    openExistingCart(trigger);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest?.('[data-product-form],[data-card-form]');
    if (!form) return;
    event.preventDefault();
    if (pendingForms.has(form)) return;
    const button = $('[data-add-button],[data-card-add]', form);
    const idInput = $('[name=id]',form);
    if (!button || button.disabled || !idInput || idInput.disabled || !idInput.value) return;
    const body = new FormData(form);
    const source = formProduct(form, body.get('id'));
    const error = $('[data-product-error],[data-cart-error]', form);
    if (error) { error.hidden=true;error.textContent=''; }
    pendingForms.add(form);form.setAttribute('aria-busy','true');
    button.disabled=true;button.textContent='Ajout en cours…';
    try {
      const response = await fetch(routes.cartAdd || '/cart/add.js',{method:'POST',body,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Le produit n’a pas pu être ajouté.');
      const items = Array.isArray(result.items) ? result.items : [result];
      const item = items.find(value => String(value.variant_id || value.id) === String(body.get('id'))) || items[0];
      if (!item || (!item.id && !item.variant_id)) throw new Error('La réponse du panier est incomplète. Vérifiez votre panier avant de réessayer.');
      rememberAdded(item);
      const confirmation = showConfirmation(item, source, button);
      refreshCart(confirmation);
    } catch (failure) {
      const message = failure.name === 'TypeError' || failure.name === 'SyntaxError'
        ? 'Connexion interrompue. Vérifiez votre panier avant de réessayer.'
        : failure.message || 'Le produit n’a pas pu être ajouté. Vérifiez votre panier avant de réessayer.';
      if (error) {error.textContent=message;error.hidden=false;}
    } finally {
      pendingForms.delete(form);form.removeAttribute('aria-busy');
      if (source.product) {
        const current=source.product.variants.find(variant=>String(variant.id)===idInput.value);
        button.disabled=idInput.disabled || !current?.available;
        button.textContent=idInput.disabled?'Combinaison indisponible':current?.available?'Ajouter au panier':'Indisponible';
      } else {button.disabled=false;button.textContent='Ajouter au panier';}
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-close-cart-confirmation]') || event.target === dialog) dialog.close();
    const previous=event.target.closest('[data-atc-prev]'), next=event.target.closest('[data-atc-next]');
    if (previous || next) track.scrollTo({left:track.scrollLeft+(previous?-1:1)*(track.clientWidth+8),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  });
  dialog.addEventListener('close', () => {
    generation++;dialog.removeAttribute('aria-busy');document.documentElement.classList.remove('erb-atc-open');
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
  track.addEventListener('scroll', updateArrows, {passive:true});
  window.addEventListener('resize', updateArrows, {passive:true});
})();
